


























import User from "@/types/user/user";
import Vue, { PropType } from "vue";
import EditUserContent from "./EditUserContent.vue";
export default Vue.extend({
  props: {
    user: {
      required: true,
      type: Object as PropType<User>,
    },
  },
  components: { EditUserContent },
  data() {
    return {
      dialog: false,
    };
  },
});
